/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Devices_DescInputs */

const vi_irrigation_devices_desc = /** @type {(inputs: Irrigation_Devices_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bộ tưới lấy từ hệ thống tưới SmartLab và trạng thái bơm thiết bị báo về gần nhất. Tự làm mới mỗi 30 giây.`)
};

/**

* @param {Irrigation_Devices_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_devices_desc = /** @type {((inputs?: Irrigation_Devices_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Devices_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_devices_desc(inputs)
});